<ng-container
    *ngIf="state?.pending?.reload !== true || state?.pending?.reset === true"
>
    <div
        class="cmps-cdk-d-flex cmps-cdk-justify-content-space-between cmps-cdk-mb-1"
    >
        <div class="cmps-cdk-flex-20 cmps-cdk-d-flex cmps-cdk-pr-1">
            <div class="cmps-cdk-mr-0dot75">
                {{ _i18n._10080_COACHING_EVENT_RANGE | translate }}
            </div>
            <div class="cmps-cdk-pos-relative">
                <select
                    class="cmps-coaching-wp-main--select"
                    (change)="_onDataRangeChange($event)"
                >
                    <ng-container *ngFor="let i of state?.dataRanges">
                        <option
                            [value]="i.dataRangeId"
                            [selected]="
                                i.dataRangeId === state?.selectedDataRangeId
                            "
                        >
                            {{ i.dataRangeName }}
                        </option>
                    </ng-container>
                </select>
                <div
                    class="cmps-cdk-pos-absolute cmps-cdk-pos-top-n0dot75 cmps-cdk-pos-right-n0dot75"
                    [cmpsTooltipTrigger]="
                        _i18n._10081_ONLY_COACHING_EVENTS_THAT_ | translate
                    "
                >
                    <cmps-icon svgIcon="information"></cmps-icon>
                </div>
            </div>
        </div>

        <div class="cmps-cdk-flex-15 cmps-cdk-d-flex cmps-cdk-px-1">
            <div class="cmps-cdk-mr-0dot75">
                {{ _i18n._10082_EVALUATION_RANGE | translate }}
            </div>
            <div class="cmps-cdk-pos-relative">
                <select
                    class="cmps-coaching-wp-main--select"
                    (change)="_onEvalRangeChange($event)"
                >
                    <ng-container *ngFor="let i of state?.evalRanges">
                        <option
                            [value]="i.evaluationRangeId"
                            [selected]="
                                i.evaluationRangeId ===
                                state?.selectedEvalRangeId
                            "
                        >
                            {{ i.evaluationRangeName }}
                        </option>
                    </ng-container>
                </select>
                <div
                    class="cmps-cdk-pos-absolute cmps-cdk-pos-top-n0dot75 cmps-cdk-pos-right-n0dot75"
                    [cmpsTooltipTrigger]="
                        _i18n._10083_THE_EVALUATION_RANGE_IS_ | translate
                    "
                >
                    <cmps-icon svgIcon="information"></cmps-icon>
                </div>
            </div>
        </div>

        <div class="cmps-cdk-flex-20 cmps-cdk-d-flex cmps-cdk-px-1">
            <div class="cmps-cdk-mr-0dot75">
                {{ _i18n._822_DRILL_PATH | translate }}
            </div>
            <div class="cmps-cdk-pos-relative">
                <select
                    class="cmps-coaching-wp-main--select"
                    (change)="_onDrillPathChange($event)"
                >
                    <ng-container *ngFor="let i of state?.drillPaths">
                        <option
                            [value]="i.identifier"
                            [selected]="
                                i.identifier === state?.selectedDrillPathId
                            "
                        >
                            {{ i.label }}
                        </option>
                    </ng-container>
                </select>
                <div
                    class="cmps-cdk-pos-absolute cmps-cdk-pos-top-n0dot75 cmps-cdk-pos-right-n0dot75"
                    [cmpsTooltipTrigger]="
                        _i18n._10095_DETERMINE_THE_DRILL_PATH_USED_ | translate
                    "
                >
                    <cmps-icon svgIcon="information"></cmps-icon>
                </div>
            </div>
        </div>

        <div class="cmps-cdk-flex-20 cmps-cdk-px-1">
            <ng-container *ngIf="state?.hasData === true">
                <span class="cmps-cdk-text-bold cmps-cdk-mr-0dot5">{{
                    _i18n._10084_SELECTED_PERIOD | translate
                }}</span>
                <span
                    >{{
                        state?.period?.start | cmpsDate: 'MMM d, y'
                    }}&nbsp;-&nbsp;{{
                        state?.period?.end | cmpsDate: 'MMM d, y'
                    }}</span
                >
            </ng-container>
        </div>

        <div class="cmps-cdk-flex-15 cmps-cdk-px-1">
            <ng-container *ngIf="state?.hasData === true">
                <span class="cmps-cdk-text-bold cmps-cdk-mr-0dot5">{{
                    _i18n._7313_LAST_UPDATE | translate
                }}</span>
                <span>{{
                    state?.period?.createdOn | cmpsDate: 'MMM d, y, h:mm a'
                }}</span>
            </ng-container>
        </div>

        <div class="cmps-cdk-flex-10 cmps-cdk-text-right">
            <button
                cmpsButton
                (click)="_onResetGridClick()"
                *ngIf="state?.hasData === true"
            >
                <cmps-icon svgIcon="cached"></cmps-icon>
                <span cmpsButtonLabel>{{
                    _i18n._9395_RESET_GRID | translate
                }}</span>
            </button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="state?.pending?.reload === true">
    <cmps-wait-status></cmps-wait-status>
</ng-container>

<ng-container
    *ngIf="state?.pending?.reload !== true && state?.hasData !== true"
>
    <div class="cmps-cdk-text-center">
        {{ _i18n._10079_NO_WINNING___DATA_IS_AVAILABLE | translate }}
    </div>
</ng-container>

<ng-container
    *ngIf="state?.pending?.reload !== true && state?.hasData === true"
>
    <div>
        <!--ngGrid will measure this div-->
        <div
            ngGrid
            class="cmps-coaching-wp-table"
            [rendererOptions]="_tableData?.rendererOpts"
            [selectTemplate]="_tableData?.selectTpl"
            [rows]="_tableData?.rows"
            [sortDefs]="_tableData?.sortDefs"
        >
            <ng-template
                gridContent
                data-type="grid"
            >
                <div></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
                data-id="bundle"
            >
                <div class="cmps-coaching-wp-table--row-bundle"></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="bundle"
                let-c="c"
            >
                <div [ngSwitch]="c.id">
                    <div
                        class="cmps-coaching-wp-table--row-bundle--pad1"
                        *ngSwitchCase="'bundle-left'"
                    ></div>
                    <div
                        class="cmps-coaching-wp-table--row-bundle--winning"
                        *ngSwitchCase="'bundle-winning'"
                    >
                        <span class="cmps-coaching-wp-table--row--text">
                            {{ _i18n._10085_WINNING | translate }}
                        </span>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row-bundle--neutral"
                        *ngSwitchCase="'bundle-neutral'"
                    >
                        <span class="cmps-coaching-wp-table--row--text">
                            {{ _i18n._10086_NEUTRAL | translate }}
                        </span>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row-bundle--losing"
                        *ngSwitchCase="'bundle-losing'"
                    >
                        <span class="cmps-coaching-wp-table--row--text">
                            {{ _i18n._10087_LOSING | translate }}
                        </span>
                    </div>
                </div>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
                data-id="header"
            >
                <div class="cmps-coaching-wp-table--row-header"></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="header"
                let-c="c"
                let-ctx="ctx"
            >
                <div>
                    <div [ngClass]="ctx?.className">
                        <button
                            class="cmps-coaching-wp-table--row-header--button"
                            (click)="_onColumnSortClick(c)"
                        >
                            <span class="cmps-coaching-wp-table--row--text">
                                {{ ctx?.data?.label | translate }}
                            </span>

                            <cmps-icon
                                [svgIcon]="
                                    state?.sortOptions?.columnId !== c.id
                                        ? 'unfold-more-horizontal'
                                        : state?.sortOptions?.order ===
                                          _SortOrder.ASC
                                        ? 'chevron-up'
                                        : 'chevron-down'
                                "
                            ></cmps-icon>
                        </button>
                    </div>
                </div>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
                data-id="content"
                let-r="r"
            >
                <div
                    class="cmps-coaching-wp-table--row"
                    [class.cmps-coaching-wp-table--row-expand]="
                        r?.context?.ctx?.values?.canExpand
                    "
                    [class.cmps-coaching-wp-table--row-grey]="
                        !r?.context?.ctx?.values?.managerMatchesCurrentManager
                    "
                    (click)="_onRowClick(r)"
                ></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="content"
                let-c="c"
                let-r="r"
            >
                <div [ngSwitch]="c.id">
                    <div
                        class="cmps-coaching-wp-table--row--left"
                        *ngSwitchCase="_ColumnId.LEFT"
                    >
                        <div
                            [style.width.px]="r?.context?.ctx?.values?.indentPx"
                            [style.min-width.px]="
                                r?.context?.ctx?.values?.indentPx
                            "
                            [style.max-width.px]="
                                r?.context?.ctx?.values?.indentPx
                            "
                        ></div>
                        <div
                            [cmpsTooltipTrigger]="
                                r?.context?.ctx?.values?.expandIconTooltip
                                    | translate
                            "
                            *ngIf="r?.context?.ctx?.values?.canExpand"
                        >
                            <cmps-icon
                                class="cmps-coaching-wp-table--row-expand--icon"
                                [svgIcon]="r?.context?.ctx?.values?.expandIcon"
                            ></cmps-icon>
                        </div>
                        <ng-container
                            *ngIf="r?.context?.ctx?.values?.showUserIcon"
                        >
                            <cmps-icon
                                class="cmps-coaching-wp-table--user-icon cmps-coaching-wp-table--user-icon-blue"
                                *ngIf="
                                    r?.context?.ctx?.values
                                        ?.managerMatchesCurrentManager
                                "
                                svgIcon="account-circle"
                            ></cmps-icon>
                            <cmps-icon
                                class="cmps-coaching-wp-table--user-icon cmps-coaching-wp-table--user-icon-grey"
                                [cmpsTooltipTrigger]="
                                    _i18n._10093_THIS_USER_NO_LONGER_REPORTS_TO_THIS_MANAGER
                                        | translate
                                "
                                *ngIf="
                                    !r?.context?.ctx?.values
                                        ?.managerMatchesCurrentManager
                                "
                                svgIcon="account-circle"
                            ></cmps-icon>
                        </ng-container>
                        <span
                            class="cmps-coaching-wp-table--row--text"
                            *ngIf="!r?.context?.ctx?.values?.showLabelTooltip"
                        >
                            {{ r?.context?.ctx?.values?.label ?? '-' }}
                        </span>
                        <span
                            class="cmps-coaching-wp-table--row--text"
                            [cmpsTooltipTrigger]="
                                r?.context?.ctx?.values?.labelTooltip
                            "
                            *ngIf="r?.context?.ctx?.values?.showLabelTooltip"
                        >
                            {{ r?.context?.ctx?.values?.label ?? '-' }}
                        </span>
                    </div>
                    <div
                        (click)="$event.stopPropagation()"
                        class="cmps-coaching-wp-table--row--total"
                        *ngSwitchCase="_ColumnId.TOTAL"
                    >
                        <span class="cmps-coaching-wp-table--row--text">
                            {{
                                r?.context?.ctx?.values?.total == null
                                    ? '-'
                                    : (r?.context?.ctx?.values?.total
                                      | cmpsNumber: '1.0-0')
                            }}
                        </span>
                        <div
                            [cmpsTooltipTrigger]="
                                _i18n.__VIEW_COMMITMENT_DETAILS | translate
                            "
                            (click)="
                                _onViewCommitmentDetailsClick(
                                    r.context.ctx.data.userId
                                )
                            "
                        >
                            <cmps-icon
                                class="view-commitment-file-search-icon"
                                svgIcon="file-search-outline"
                            ></cmps-icon>
                        </div>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row--winning-percentage"
                        *ngSwitchCase="_ColumnId.WINNING_PERCENTAGE"
                    >
                        <span
                            class="cmps-coaching-wp-table--row--text"
                            [style.color]="
                                r?.context?.ctx?.values?.winningThresholdColour
                            "
                        >
                            {{
                                r?.context?.ctx?.values?.winningPercentage ==
                                null
                                    ? '-'
                                    : (r?.context?.ctx?.values
                                          ?.winningPercentage
                                      | cmpsPercent: '1.2-2')
                            }}
                        </span>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row--winning-number"
                        *ngSwitchCase="_ColumnId.WINNING_NUMBER"
                    >
                        <span class="cmps-coaching-wp-table--row--text">
                            {{
                                r?.context?.ctx?.values?.winningNumber == null
                                    ? '-'
                                    : (r?.context?.ctx?.values?.winningNumber
                                      | cmpsNumber: '1.0-0')
                            }}
                        </span>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row--neutral-percentage"
                        *ngSwitchCase="_ColumnId.NEUTRAL_PERCENTAGE"
                    >
                        <span class="cmps-coaching-wp-table--row--text">
                            {{
                                r?.context?.ctx?.values?.neutralPercentage ==
                                null
                                    ? '-'
                                    : (r?.context?.ctx?.values
                                          ?.neutralPercentage
                                      | cmpsPercent: '1.2-2')
                            }}
                        </span>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row--neutral-number"
                        *ngSwitchCase="_ColumnId.NEUTRAL_NUMBER"
                    >
                        <span class="cmps-coaching-wp-table--row--text">
                            {{
                                r?.context?.ctx?.values?.neutralNumber == null
                                    ? '-'
                                    : (r?.context?.ctx?.values?.neutralNumber
                                      | cmpsNumber: '1.0-0')
                            }}
                        </span>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row--losing-percentage"
                        *ngSwitchCase="_ColumnId.LOSING_PERCENTAGE"
                    >
                        <span class="cmps-coaching-wp-table--row--text">
                            {{
                                r?.context?.ctx?.values?.losingPercentage ==
                                null
                                    ? '-'
                                    : (r?.context?.ctx?.values?.losingPercentage
                                      | cmpsPercent: '1.2-2')
                            }}
                        </span>
                    </div>
                    <div
                        class="cmps-coaching-wp-table--row--losing-number"
                        *ngSwitchCase="_ColumnId.LOSING_NUMBER"
                    >
                        <span class="cmps-coaching-wp-table--row--text">
                            {{
                                r?.context?.ctx?.values?.losingNumber == null
                                    ? '-'
                                    : (r?.context?.ctx?.values?.losingNumber
                                      | cmpsNumber: '1.0-0')
                            }}
                        </span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</ng-container>
